import { all } from 'redux-saga/effects';
//import { appSaga } from 'store/app/saga';
import { authSaga } from 'store/auth/saga';
import { userSaga } from 'store/user/saga';

export default function* () {
	yield all([authSaga(), userSaga()]);
}
